import { render, staticRenderFns } from "./handpickArticleAdd.vue?vue&type=template&id=adda0f28&scoped=true&"
import script from "./handpickArticleAdd.vue?vue&type=script&lang=js&"
export * from "./handpickArticleAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adda0f28",
  null
  
)

export default component.exports